import { useMutation } from "@tanstack/react-query";
import { Methods } from "../../Constants/ApiConstants";
import { EndPoints } from "../../Constants/endpoints";
import {
  GeneralResponse,
  IAddPrescription,
} from "../../interface/GeneralResponse";
import Api from "../generalApi/Api";

interface MutationParams {
  data: IAddPrescription;
  patientId: number;
}

const useAddPrescriptionToPatient = () => {
  const mutation = useMutation({
    mutationFn: ({
      data,
      patientId,
    }: MutationParams): Promise<GeneralResponse> => {
      return Api<IAddPrescription, GeneralResponse>({
        method: Methods.POST,
        endpoint: `${EndPoints.CreatePrescription}/${patientId}`,
        body: data,
      });
    },
  });

  return mutation;
};

export default useAddPrescriptionToPatient;
